import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Dashboard from "../Dashboard";
import CreateAdmin from "./CreateAdmin";
import VisitorList from "../components/VisitorList";
import "../styles/Admin.css";

// Fonction pour calculer le taux de ressemblance entre perdu et ramassé
function calculerTauxRessemblance(perdu, ramasse) {
  let score = 0;
  let total = 3; // par exemple on compare nom, prenom, date_naissance

  if (perdu.nom?.toLowerCase() === ramasse.nom?.toLowerCase()) score++;
  if (perdu.prenom?.toLowerCase() === ramasse.prenom?.toLowerCase()) score++;
  if (perdu.date_naissance === ramasse.date_naissance) score++;

  return (score / total) * 100;
}

// Composant Seuil pour afficher le tableau avec noms et taux de ressemblance
const Seuil = ({ dataComparaison }) => {
  return (
    <div>
      <h2>Seuils de ressemblance (%)</h2>
      <table className="table-seuil">
        <thead>
          <tr>
            <th>Nom perdu</th>
            <th>Nom ramassé</th>
            <th>Seuil (%)</th>
          </tr>
        </thead>
        <tbody>
          {dataComparaison.map(({ id, perdu, ramasse, seuil }) => (
            <tr key={id}>
              <td>{perdu.nom || "N/A"}</td>
              <td>{ramasse.nom || "N/A"}</td>
              <td>{seuil.toFixed(0)}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const Admin = () => {
  const [tab, setTab] = useState("dashboard");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Exemple de données perdues et ramassées (à remplacer par données réelles)
  const [dataPerdus] = useState([
    { nom: "Durand", prenom: "Jean", date_naissance: "1980-02-15" },
    { nom: "Martin", prenom: "Sophie", date_naissance: "1990-06-20" },
    { nom: "Bernard", prenom: "Paul", date_naissance: "1975-11-05" },
  ]);

  const [dataRamasses] = useState([
    { nom: "Durand", prenom: "Jean", date_naissance: "1980-02-15" },
    { nom: "Martin", prenom: "Sophia", date_naissance: "1990-06-20" },
    { nom: "Bernard", prenom: "Paul", date_naissance: "1974-11-05" },
  ]);

  // Calculer la comparaison des données pour le tableau Seuil
  const dataComparaison = dataPerdus.map((perdu, idx) => {
    const ramasse = dataRamasses[idx] || {};
    return {
      id: idx,
      perdu,
      ramasse,
      seuil: calculerTauxRessemblance(perdu, ramasse),
    };
  });

  const handleLogout = () => {
    try {
      localStorage.removeItem("adminEmail");
      localStorage.removeItem("token");
    } catch (_) {}
    navigate("/admin-login", { replace: true });
  };

  const handleSelect = (value) => {
    setMenuOpen(false);
    if (value === "logout") {
      handleLogout();
      setTab("dashboard");
    } else {
      setTab(value);
    }
  };

  return (
    <div className="admin-layout">
      <div className="menu-wrapper">
        <button
          className="menu-button"
          aria-haspopup="true"
          aria-expanded={menuOpen}
          aria-label="Ouvrir le menu de navigation"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="menu-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        {menuOpen && (
          <ul className="menu-dropdown" role="menu">
            <li
              role="menuitem"
              tabIndex={0}
              className={tab === "dashboard" ? "active" : ""}
              onClick={() => handleSelect("dashboard")}
              onKeyDown={(e) => e.key === "Enter" && handleSelect("dashboard")}
            >
              Tableau de bord
            </li>
            <li
              role="menuitem"
              tabIndex={0}
              className={tab === "add-admin" ? "active" : ""}
              onClick={() => handleSelect("add-admin")}
              onKeyDown={(e) => e.key === "Enter" && handleSelect("add-admin")}
            >
              Ajouter un admin
            </li>
            <li
              role="menuitem"
              tabIndex={0}
              className={tab === "visitors" ? "active" : ""}
              onClick={() => handleSelect("visitors")}
              onKeyDown={(e) => e.key === "Enter" && handleSelect("visitors")}
            >
              Liste des visiteurs
            </li>
            <li
              role="menuitem"
              tabIndex={0}
              onClick={() => handleSelect("logout")}
              onKeyDown={(e) => e.key === "Enter" && handleSelect("logout")}
            >
              Se déconnecter
            </li>
          </ul>
        )}
      </div>

      <main className="admin-main">
        {tab === "dashboard" && <Dashboard />}
        {tab === "add-admin" && <CreateAdmin />}
        {tab === "visitors" && <VisitorList />}
      </main>
    </div>
  );
};

export default Admin;